import React, { useState, useRef } from "react";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import RecommendedProductCard from "./RecommendedProductCard";
import "./RecommendedProducts.css";

const RecommendedProducts = ({ products }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const scrollContainerRef = useRef(null);

  const scrollLeft = () => {
    if (currentIndex > 0) {
      const newIndex = currentIndex - 1;
      setCurrentIndex(newIndex);
      scrollContainerRef.current?.scrollTo({
        left: newIndex * scrollContainerRef.current.offsetWidth,
        behavior: "smooth",
      });
    }
  };

  const scrollRight = () => {
    if (currentIndex < products.length - 1) {
      const newIndex = currentIndex + 1;
      setCurrentIndex(newIndex);
      scrollContainerRef.current?.scrollTo({
        left: newIndex * scrollContainerRef.current.offsetWidth,
        behavior: "smooth",
      });
    }
  };

  if (!products || products.length === 0) {
    return null;
  }

  return (
    <div className="recommendedProducts">
      <h4 className="recommendedProducts__title">You may also like</h4>

      <div className="recommendedProducts__container">
        <div className="recommendedProducts__scroll" ref={scrollContainerRef}>
          <div className="recommendedProducts__list">
            {products.map((product) => (
              <div key={product._id} className="recommendedProducts__item">
                <RecommendedProductCard product={product} />
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="recommendedProducts__navigation-row">
        {products.length > 1 && (
          <button
            className={`recommendedProducts__arrow recommendedProducts__arrow--left ${currentIndex === 0 ? "recommendedProducts__arrow--disabled" : ""
              }`}
            onClick={scrollLeft}
            disabled={currentIndex === 0}
          >
            <IoIosArrowBack size={20} />
          </button>
        )}

        <div className="recommendedProducts__dots">
          {products.map((_, index) => (
            <button
              key={index}
              className={`recommendedProducts__dot ${index === currentIndex ? "recommendedProducts__dot--active" : ""
                }`}
              onClick={() => {
                setCurrentIndex(index);
                scrollContainerRef.current?.scrollTo({
                  left: index * scrollContainerRef.current.offsetWidth,
                  behavior: "smooth",
                });
              }}
            />
          ))}
        </div>

        {products.length > 1 && (
          <button
            className={`recommendedProducts__arrow recommendedProducts__arrow--right ${currentIndex >= products.length - 1 ? "recommendedProducts__arrow--disabled" : ""
              }`}
            onClick={scrollRight}
            disabled={currentIndex >= products.length - 1}
          >
            <IoIosArrowForward size={20} />
          </button>
        )}
      </div>
    </div>
  );
};

export default RecommendedProducts;
